import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import TimeZonePicker from './TimeZonePicker/TimeZonePicker';
import _ from "lodash";

import { debounce } from "throttle-debounce";

import { connect } from "react-redux";
import {
  Form,
  Table,
  Button,
  Grid,
  Segment,
  Header,
  Modal,
  Radio,
} from "semantic-ui-react";

import {
  deleteWorkspace,
  createWorkspace,
  editWorkspace,
  checkDeleteWorkspacePermission,
  setWorkspaceToDelete,
  saveWorkspaceLevelSettings,
  getWorkspaceLevelSettings,

} from "../../../actions/adminConsole";

import { getWorkspaces } from "../../../actions/workspace";

import { useTranslation } from "react-i18next";

import "./WorkspaceEditor.css";
import { getClientTimezone } from "../../../utils/format";

export const WorkspaceEditor = ({
  organizationCode,
  deleteWorkspace,
  createWorkspace,
  editWorkspace,
  checkDeleteWorkspacePermission,
  needsWorkspaceDeleteRefresh,
  checkingWorkspaceDeleteFreshness,
  workspaces,
  setWorkspaceToDelete,
  workspaceToDelete,
  isConnected,
  workspaceLevelSettings,
  getWorkspaceLevelSettings,
  saveWorkspaceLevelSettings,
}) => {
  const { t } = useTranslation();

  const [editableWorkspace, setEditableWorkspace] = useState(null);

  const [showCreateForm, setShowCreateForm] = useState(false);

  const [workspaceNameError, setWorkspaceNameError] = useState(null);

  const [newWorkspaceTimeZone, setNewWorkspaceTimeZone] = useState(getClientTimezone())

  const [fillWithDemoData, setFillWithDemoData] = useState(false)

  const [editSettingsByWorkspace, setEditSettingsByWorkspace] = useState(false)
  const [variabilityDaysRangeError, setVariabilityDaysRangeError] = useState(null)
  const [decimalsNumberError, setDecimalsNumberError] = useState(null)

  const [currentWorkspaceLevelSettings, setNewWorkspaceLevelSettings] = useState({...workspaceLevelSettings})
  useEffect(() => {
    if(workspaceLevelSettings){
      setNewWorkspaceLevelSettings(workspaceLevelSettings)
    }
  }, [workspaceLevelSettings])
  const submitWorkspace = (workspace = editableWorkspace) => {
    workspace = { ...workspace, name: workspace.name.trim(), workspace_timezone: workspace.timezone };
    if (
      _.includes(
        workspaces
          .filter((existingWorskpace) => existingWorskpace.id !== workspace.id)
          .map((existingWorskpace) =>
            existingWorskpace.name.trim().replace(/ /g, "")
          ),
        workspace.name.trim().replace(/ /g, "")
      )
    ) {
      setWorkspaceNameError({
        content: t("account.adminConsole.duplicateWorkspaceNameError"),
        pointing: "below",
      });
      return;
    } else if (workspace.name === "") {
      setWorkspaceNameError({
        content: t("account.adminConsole.emptyWorkspaceNameError"),
        pointing: "below",
      });
      return;
    }
    _.has(workspace, "id")
      ? editWorkspace(workspace)
      : createWorkspace(workspace, fillWithDemoData);

    setNewWorkspaceTimeZone(getClientTimezone())
    setEditableWorkspace(null);
    setShowCreateForm(false);
    setFillWithDemoData(false)

  };

  const removeWithConfirmation = async (workspace) => {
    setWorkspaceToDelete(workspace);
    // Permission pre-flight check
    checkDeleteWorkspacePermission();
  };


  const debouncedWorkspaceData = debounce(500, (fieldData) => {
    setEditableWorkspace(fieldData)
  });

  const onChangeDaysRange = (inputVal)=>{
    const val = inputVal.replace(/\D/g, "");
    const parsed = val === "" ? null : parseInt(val, 10);
    if (parsed === null || parsed < 1 || parsed > 730) {
      setVariabilityDaysRangeError(t("account.adminConsole.variabilityDaysRangeError"));
    } else {
      setVariabilityDaysRangeError(null);
    }
    setNewWorkspaceLevelSettings({
      ...currentWorkspaceLevelSettings,
      variability_days_range: parsed,
    });
  }

  const onChangeDecimalsNumber = (inputVal) => {
    const val = inputVal.replace(/\D/g, "");
    const parsed = val === "" ? null : parseInt(val, 10);
    if (parsed === null || parsed < 0 || parsed > 10) {
      setDecimalsNumberError(t("account.adminConsole.decimalsNumberError"));
    } else {
      setDecimalsNumberError(null);
    }
    setNewWorkspaceLevelSettings({
      ...currentWorkspaceLevelSettings,
      decimals_number: parsed,
    });
  }

  const renderDeleteModal = () => {
    if (
      checkingWorkspaceDeleteFreshness ||
      needsWorkspaceDeleteRefresh ||
      _.isEmpty(workspaceToDelete)
    ) {
      return null;
    }

    return (
      <Modal open>
        <Modal.Header>
          Delete workspace {`"${workspaceToDelete.name}"`} ?
        </Modal.Header>
        <Modal.Content>
          <Form
            onSubmit={(e) => {
              e.preventDefault();

              if (e.target["workspace-name"].value === workspaceToDelete.name) {
                deleteWorkspace(workspaceToDelete.id);
                setWorkspaceToDelete(null);
              } else {
                setWorkspaceNameError({
                  content: t(
                    "account.adminConsole.workspaceNameDoesNotMatchError"
                  ),
                  pointing: "above",
                });
              }
              return;
            }}
          >
            <Form.Input
              required
              error={workspaceNameError}
              label={t("account.adminConsole.confirmWorkspaceToDelete")}
              placeholder={t("account.adminConsole.workspaceNameColumn")}
              name="workspace-name"
            />
            <div className="create-workspace-form-buttons">
              <Button disabled={!isConnected} type="submit" negative>
                {t("account.adminConsole.deleteWorkspace")}
              </Button>
              <Button
                disabled={!isConnected}
                onClick={() => {
                  setWorkspaceToDelete(null);
                }}
              >
                {t("cancel")}
              </Button>
            </div>
          </Form>
        </Modal.Content>
      </Modal>
    );
  };

  const renderSettingsByWorkspace = () => {
    if(!editSettingsByWorkspace){
      return null
    }
    return (
      <Modal open>
        <Modal.Header>
          {t("account.adminConsole.settingsByWorkspace")}
        </Modal.Header>
        <Modal.Content key={'somestring'} className="workspace-settings-modal-content">
          <div className="workspace-settings-grid">
            <label>{t("account.adminConsole.rulesByItem")}</label>
            <Radio
              toggle
              checked={currentWorkspaceLevelSettings.buffer_rules_by_item}
              onChange={() => {
                setNewWorkspaceLevelSettings({
                  ...currentWorkspaceLevelSettings,
                  buffer_rules_by_item: !currentWorkspaceLevelSettings.buffer_rules_by_item,
                });
              }}
            />
            <label>{t("account.adminConsole.variabilityDaysRange")}</label>
            <div className="workspace-settings-input-wrapper">
              <div className="workspace-settings-input-container">
                <input
                  type="number"
                  min={1}
                  max={730}
                  step={1}
                  onKeyDown={(e) => {
                    if (e.key.length === 1 && !/\d/.test(e.key)) e.preventDefault();
                  }}
                  value={currentWorkspaceLevelSettings.variability_days_range ?? ""}
                  onChange={(e)=>{onChangeDaysRange(e.target.value)}}
                  className="workspace-settings-integer-input"
                />
                <span className="workspace-settings-input-days-suffix">{t("simulation.days")}</span>
              </div>
              <div className={`workspace-settings-input-error${variabilityDaysRangeError ? "" : " workspace-settings-input-error--hidden"}`}>
                {variabilityDaysRangeError || " "}
              </div>
            </div>
            <label>{t("account.adminConsole.decimalsNumber")}</label>
            <div className="workspace-settings-input-wrapper">
              <div className="workspace-settings-input-container">
                <input
                  type="number"
                  min={0}
                  max={10}
                  step={1}
                  onKeyDown={(e) => {
                    if (e.key.length === 1 && !/\d/.test(e.key)) e.preventDefault();
                  }}
                  value={currentWorkspaceLevelSettings.decimals_number ?? 2}
                  onChange={(e) => { onChangeDecimalsNumber(e.target.value) }}
                  className="workspace-settings-integer-input"
                />
                <span className="workspace-settings-input-days-suffix">{t("account.adminConsole.decimals")}</span>
              </div>
              <div className={`workspace-settings-input-error${decimalsNumberError ? "" : " workspace-settings-input-error--hidden"}`}>
                {decimalsNumberError || " "}
              </div>
            </div>
          </div>
            <div className="create-workspace-form-buttons">
              <Button
               className="workspace-save-button"
               disabled={!isConnected || !!variabilityDaysRangeError || !!decimalsNumberError}
               onClick={()=>{
                saveWorkspaceLevelSettings(currentWorkspaceLevelSettings);
                setEditSettingsByWorkspace(false);
                submitWorkspace(editableWorkspace)
              }}

               negative
               >
                {t("save")}
              </Button>
              <Button
                disabled={!isConnected}
                onClick={() => {
                  setVariabilityDaysRangeError(null);
                  setDecimalsNumberError(null);
                  setEditSettingsByWorkspace(false);
                }}
              >
                {t("cancel")}
              </Button>
            </div>
        </Modal.Content>
      </Modal>
    );
  }

  return (
    <Grid className="workspace-editor">
      {renderDeleteModal()}
      {renderSettingsByWorkspace()}

      <Grid.Row>
        <Grid.Column width={8}>
          {showCreateForm ? (
            <Segment className="create-workspace-container">
             <Header className="create-workspace-header">{t("account.adminConsole.newWorkspace")}</Header>
              <Form
                className="create-workspace-container"
                onSubmit={(e) => {
                  e.preventDefault();
                  submitWorkspace(
                    {
                      name: e.target["workspace-name"].value,
                      timezone: newWorkspaceTimeZone
                    }
                  );
                }}
              >

                <Form.Input
                  label={t("account.adminConsole.workspaceNameLabel")}
                  error={workspaceNameError}
                  placeholder="Workspace Name"
                  name="workspace-name"
                />

                <Form.Field>
                  <label >{t("account.adminConsole.workspaceTimezoneLabel")}</label>
                  <TimeZonePicker
                    value={newWorkspaceTimeZone}
                    onChange={(e, data) => setNewWorkspaceTimeZone(data.value)} />
                </Form.Field>
                <Form.Field>
                <label >{t("account.adminConsole.fillWithDemoData")}</label>
                    <Radio
                    toggle
                    onChange={() => {
                      setFillWithDemoData(!fillWithDemoData)
                    }}
                  />
                </Form.Field>
                  

                <div className="create-workspace-form-buttons">
                  <Button disabled={!isConnected} type="submit" positive>
                    {t("save")}
                  </Button>
                  <Button
                    onClick={() => {
                      setShowCreateForm(false);
                      setWorkspaceNameError(null);
                    }}
                  >
                    {t("cancel")}
                  </Button>
                </div>

              </Form>
            </Segment>
          ) : (
              <Button
                disabled={!isConnected}
                floated="left"
                primary
                className="create-workspace-button"
                onClick={() => {
                  setWorkspaceNameError(null);
                  setEditableWorkspace(null);
                  setShowCreateForm(true);
                }}
              >
                {t("account.adminConsole.createWorkspace")}
              </Button>
            )}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <div className="org-code-container">{t("account.adminConsole.organizationCode").concat(organizationCode)}</div>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={12}>
          {_.isEmpty(workspaces) ? (
            <Segment placeholder>
              <Header icon> {t("account.adminConsole.noWorkspaces")}</Header>
            </Segment>
          ) : (
              <Table celled>
                <Table.Header>
                  <Table.Row textAlign="center">
                    <Table.HeaderCell>
                      {t("account.adminConsole.workspaceNameLabel")}
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      {t("account.adminConsole.workspaceCode")}
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      {t("account.adminConsole.workspaceTimezoneLabel")}
                    </Table.HeaderCell>
                    <Table.HeaderCell></Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {workspaces.map((workspace) =>
                    editableWorkspace && editableWorkspace.id === workspace.id ? (
                      <Table.Row key={workspace.id} className="workspace-row">
                        <Table.Cell>
                          <Form.Input
                            fluid
                            error={workspaceNameError}
                            defaultValue={editableWorkspace.name}
                            onChange={(e) =>
                              debouncedWorkspaceData({
                                ...editableWorkspace,
                                name: e.target.value,
                              })
                            }
                          />
                        </Table.Cell>
                        <Table.Cell>{workspace.workspace_code}</Table.Cell>
                        <Table.Cell>
                          <TimeZonePicker
                            value={editableWorkspace.timezone}
                            onChange={(e, data) => setEditableWorkspace({
                              ...editableWorkspace,
                              timezone: data.value,
                            })} />
                        </Table.Cell>

                        <Table.Cell textAlign="center" collapsing>
                          <Button
                            disabled={!isConnected || _.isNil(editableWorkspace)}
                            positive
                            size="small"
                            onClick={() =>{ 
                              setEditSettingsByWorkspace(true)}}
                            className="workspace-row-left-button"
                          >
                            {t("account.workspace.settings")}
                          </Button>
                          <Button
                            disabled={!isConnected}
                            positive
                            size="small"
                            onClick={() => submitWorkspace(editableWorkspace)}
                            className="workspace-row-left-button"
                          >
                            {t("save")}
                          </Button>
                          <Button
                            disabled={!isConnected}
                            size="small"
                            onClick={() => setEditableWorkspace(null)}
                          >
                            {t("cancel")}
                          </Button>
                        </Table.Cell>
                      </Table.Row>
                    ) : (
                        <Table.Row key={workspace.id} className="workspace-row">
                          <Table.Cell>{workspace.name}</Table.Cell>
                          <Table.Cell>{workspace.workspace_code}</Table.Cell>
                          <Table.Cell>{t(`timezones.${workspace.timezone}`)}</Table.Cell>
                          <Table.Cell textAlign="center" collapsing>
                            <Button
                              disabled={!isConnected}
                              className="workspace-row-left-button"
                              icon="pencil"
                              size="tiny"
                              color="teal"
                              onClick={() => {
                                setShowCreateForm(false);
                                setWorkspaceNameError(null);
                                setEditableWorkspace(workspace);
                                getWorkspaceLevelSettings(workspace.id);
                              }}
                            ></Button>
                            <Button
                              disabled={!isConnected}
                              size="tiny"
                              icon="trash"
                              negative
                              onClick={() => {
                                setWorkspaceNameError(null);
                                removeWithConfirmation(workspace);
                              }}
                            ></Button>
                          </Table.Cell>
                        </Table.Row>
                      )
                  )}
                </Table.Body>
              </Table>
            )}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  checkingWorkspaceDeleteFreshness:
    state.adminConsole.checkingWorkspaceDeleteFreshness,
  needsWorkspaceDeleteRefresh: state.adminConsole.needsWorkspaceDeleteRefresh,
  workspaceToDelete: state.adminConsole.workspaceToDelete,
  workspaces: _.isEmpty(state.adminConsole.organization)
    ? []
    : state.adminConsole.organization.workspaces,
  isConnected: state.auth.isConnected,
  workspaceLevelSettings: state.adminConsole.workspaceLevelSettings

});

WorkspaceEditor.propTypes = {
  needsWorkspaceDeleteRefresh: PropTypes.bool.isRequired,
  organizationCode: PropTypes.string,
  getWorkspaces: PropTypes.func.isRequired,
  deleteWorkspace: PropTypes.func.isRequired,
  createWorkspace: PropTypes.func.isRequired,
  editWorkspace: PropTypes.func.isRequired,
  checkDeleteWorkspacePermission: PropTypes.func.isRequired,
  workspaces: PropTypes.arrayOf(PropTypes.object).isRequired,
  workspaceToDelete: PropTypes.object,
  setWorkspaceToDelete: PropTypes.func.isRequired,
  checkingWorkspaceDeleteFreshness: PropTypes.bool.isRequired,
  isConnected: PropTypes.bool,
  workspaceLevelSettings: PropTypes.object,
  getWorkspaceLevelSettings: PropTypes.func,
  saveWorkspaceLevelSettings: PropTypes.func
};

export default connect(mapStateToProps, {
  getWorkspaces,
  deleteWorkspace,
  createWorkspace,
  editWorkspace,
  checkDeleteWorkspacePermission,
  setWorkspaceToDelete,
  getWorkspaceLevelSettings,
  saveWorkspaceLevelSettings,
})(WorkspaceEditor);
